import { Build } from "@stencil/core";
import { importMetaURL } from "./meta";

export const environmentName = (() => {
  if (Build.isTesting) {
    return "testing";
  }
  if (Build.isDev) {
    return "local";
  }
  // Get the location the script was loaded from. Fall back to the current URL
  // if for some reason that doesn't work. I see no reason it should ever fail,
  // but it doesn't hurt to be extra sure here, I think.
  const url = new URL(importMetaURL, location.href);
  if (
    // Code loaded from non-production sources should use staging APIs
    url.hostname === "zapier-staging.com" ||
    url.hostname.endsWith(".zapier-staging.com") ||
    url.hostname.endsWith(".zapier-deployment.com") ||
    // Allow production code to hit staging APIs if we opt-in via setting query
    // params on the script tag that includes the JS
    url.searchParams.get("environment") === "staging"
  ) {
    return "staging";
  }
  return "production";
})();

export const shouldSendAnalytics =
  environmentName === "staging" ||
  environmentName === "production" ||
  environmentName === "testing";

export const apiURL = {
  local: "https://api.zapier-staging.com",
  testing: "https://api.zapier-staging.com",
  staging: "https://api.zapier-staging.com",
  production: "https://api.zapier.com",
}[environmentName];

export const zapierURL = {
  local: "http://localhost:3000",
  testing: "https://zapier-staging.com",
  staging: "https://zapier-staging.com",
  production: "https://zapier.com",
}[environmentName];

export const pseSupportedTemplates = {
  local: new Set(["19937", "18341", "18200", "19943", "19961"]),
  testing: new Set(["19937", "18341", "18200", "19943", "19961"]),
  staging: new Set(["19937", "18341", "18200", "19943", "19961"]),
  production: new Set(["19937", "18341", "18200", "1552982", "19943", "19961"]),
}[environmentName];
